module.exports = __webpack_public_path__ + "img/top-suffix.b2d83b58.png";